import React, { Suspense } from 'react';
import PageTitle from 'common/components/navigation/containers/PageTitle';
import PageSpinner from 'common/components/spinner/PageSpinner';

const LoadableComponentActiveAlarms = React.lazy(() =>
    import('./TechnicalAlarms'),
);

export default () => (
    <>
        <PageTitle pluginId="technicalAlarms" pluginNameTag="TechnicalAlarms" />
        <Suspense fallback={<PageSpinner />}>
            <LoadableComponentActiveAlarms />
        </Suspense>
    </>
);
